<template>
  <v-row class="mx-2">
    <v-col
      class="col-12 col-sm-6 col-md-3 pb-3 mb-n2 px-2"
      v-for="(document, index) in documents"
      :key="index"
    >
      <v-card elevation="1">
        <v-card-title class="py-0 px-4">
          <v-icon class="d-block mx-auto display-1">mdi-file-pdf</v-icon>
        </v-card-title>
        <v-card-text class="pb-0 px-4">
          <v-list two-line>
            <v-list-item-content class="pb-0">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item-title
                    v-bind="attrs"
                    v-on="on"
                    class="primary--text font-weight-medium"
                    >{{ document.name }}</v-list-item-title
                  >
                </template>
                <span>{{ document.name }}</span>
              </v-tooltip>
              <v-list-item-subtitle
                class="grey--text caption"
                :class="{ hidden: !document.sizeInBytes }"
                >{{ document.sizeInBytes | megabytes }}</v-list-item-subtitle
              >
            </v-list-item-content>
          </v-list>
        </v-card-text>
        <v-card-actions class="px-2 d-flex justify-end">
          <v-icon
            v-if="personData.userId == currentUser.id"
            class="delete-document"
            @click="deletePersonDocument(document.id)"
            >mdi-trash-can-outline</v-icon
          >
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="primary"
            small
            @click="downloadFile(document)"
            >{{ lang.actions.download }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    personData: {
      type: Object,
      default() {
        return { id: "yes" };
      },
    },
    currentUser: {
      type: Object,
      default() {
        return { id: "no" };
      },
    },
    documents: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    downloadFile(doc) {
      if (this.$route.path.includes("demo")) {
        this.$emit("download-file-demo");
      } else {
        const link = document.createElement("a");
        link.href = doc.documentUrl;
        link.download = doc.name;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    deletePersonDocument(id) {
      if (this.$route.path.includes("demo")) {
        this.$emit("download-file-demo");
      } else {
        this.$emit("delete-person-document", id);
      }
    },
  },
  computed: {
    lang() {
      return this.$store.state.langObj || {};
    },
  },
};
</script>

<style lang="scss" scoped>
// .v-card,
// .v-list-item__content,
// .v-list {
//   background: #f1efef !important;
// }
.hidden {
  visibility: hidden;
}
.delete-document {
  cursor: pointer;
  color: rgb(203, 28, 28);
}
</style>